class CarouselImageSmall {

  constructor(parentElementId) {
    this.parentElementId = parentElementId
    this.parent = document.getElementById(parentElementId)
    this.carouselSmallAutoInterval = null;
    this.carouselSmallSelectedIndex = 0;
    this.carouselSmallScrollTimeout = null;
    this.carouselSmallIntervalTime = 8000;
    this.carouselSmallScrollLeft = 0;
    this.carouselSmallTouch = null;

    this.carouselSmallDots = this.parent.getElementsByClassName(`carousel-small-dot`);
    this.carouselSmallSwipeableObject = this.parent.getElementsByClassName(`carousel-small-swipeable-object`)[0];
    this.carouselSmallSwipeableElements = this.parent.getElementsByClassName(`carousel-small-slide`);
    this.scrollDivSmall = this.parent.getElementsByClassName(`carousel-small-scrolldiv`)[0];

    /////////////ADD LISTENERS ///////////////
    this.carouselSmallSwipeableObject.addEventListener('carouselTouchstart', (event) => carouselTouchstart(event));
    this.carouselSmallSwipeableObject.addEventListener('carouselTouchend', (event) => carouselTouchend(event));

    // TODO: Make this specific to this carousel

    this.carouselSmallUpdateDots();
  }

  ///////////// GET ELEMENTS ////////////////

  //////////// METHODS ///////////////
  carouselSmallNextPress() {
    this.carouselSmallSetAuto(); // Reset auto interval
    this.carouselSmallNext();
  }
  
  carouselSmallPrevPress() {
    if (this.carouselSmallSelectedIndex == 0) return;
    this.carouselSmallSetAuto(); // Reset auto interval
    this.carouselSmallPrev();
  }

  carouselSmallSetIndex(index) {
    this.carouselSmallSetAuto(); // Reset auto interval
    this.carouselSmallSelectedIndex = index - 1;
    this.carouselSmallSetScroll();
  }

  carouselSmallNext() {
    if(!this.carouselSmallSwipeableElements){
      this.carouselSmallSwipeableElements = parent.getElementsByClassName('carousel-small-slide');
    }
    if (this.carouselSmallSelectedIndex === this.carouselSmallSwipeableElements.length - 1) this.carouselSmallSelectedIndex = 0;
    else this.carouselSmallSelectedIndex++;
    this.carouselSmallSetScroll();
  }

  carouselSmallPrev() {
    if (this.carouselSmallSelectedIndex === 0) this.carouselSmallSelectedIndex = this.carouselSmallSwipeableElements.length - 1;
    else this.carouselSmallSelectedIndex--;
    this.carouselSmallSetScroll();
  }

  carouselSmallSetScroll() {
    if (!this.scrollDivSmall) return;
    this.scrollDivSmall.scrollLeft = this.scrollDivSmall.clientWidth * this.carouselSmallSelectedIndex;
    this.carouselSmallScrollLeft = this.scrollDivSmall.scrollLeft;
    this.carouselSmallUpdateDots();
  }

  carouselSmallSetAuto() {
    clearInterval(this.carouselSmallAutoInterval);
    this.carouselSmallAutoInterval = setInterval(this.carouselSmallNext.bind(this), this.carouselSmallIntervalTime)  }

  carouselSmallTouchstart(e) {
    this.carouselSmallTouch = new TouchEvent(e);
  }

  carouselSmallTouchend(e) {
    if (!this.carouselSmallTouch) return;
    this.carouselSmallTouch.setEndEvent(e);
    if (this.carouselSmallTouch.isSwipeRight()) this.carouselSmallPrevPress();
    else if (this.carouselSmallTouch.isSwipeLeft()) this.carouselNextPress();
    this.carouselSmallTouch = null;
  }

  carouselSmallUpdateDots() {
    for (let i = 0; i < this.carouselSmallDots.length; i++) {
      if (i === this.carouselSmallSelectedIndex) {
        this.carouselSmallDots[i].classList.add('bg-copper');
        this.carouselSmallDots[i].classList.remove('bg-gray-300');
      } else {
        this.carouselSmallDots[i].classList.remove('bg-copper');
        this.carouselSmallDots[i].classList.add('bg-gray-300');
      }
    }
  }
}

const carouselImageSmallInit = () => {
  const doneLoadingCarouselSmall = new CustomEvent('doneloadingcarouselsmall', {
    detail: {},
  });
  document.dispatchEvent(doneLoadingCarouselSmall);
}
carouselImageSmallInit()

